export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const BASE_CALENDAR_URL = process.env.REACT_APP_CALENDAR_API_URL;

// this is used to run the flask local environment because headers with _ values
// get silently dropped
export const GROUP_AUTH_HEADER_NAME = process.env.REACT_APP_USES_LOCAL_BACKEND
  ? "group-auth-type"
  : "group_auth_type";
